import React from 'react';
import { Trans } from '@lingui/react';
import { Box } from '@components/layout/Grid';
import { ProgramsDuration } from '@components/texts';
import { TextWithIcon } from '@components/TextWithIcon';
import { WhiteSectionWrapper } from '@components/wrappers';

const ProgramMetaCard = () => {
  return (
    <h1>
      Culpa incididunt proident minim ullamco qui. Consequat adipisicing esse
      cupidatat sit labore reprehenderit ut nostrud non velit non officia eu eu.
      Ex non officia dolore do labore proident aliqua cupidatat Lorem dolore et
      incididunt.
    </h1>
  );

  return (
    <Box p="20px" as={WhiteSectionWrapper}>
      <Box>
        <ProgramsDuration>
          <TextWithIcon icon="ygb-icon-programlenght-ic" iconSize="20px">
            <Trans id={'programs.duration'} message={`30 day program`} />
          </TextWithIcon>
        </ProgramsDuration>
      </Box>
    </Box>
  );
};

export default ProgramMetaCard;
